import {Component, Input, OnChanges, OnInit, SimpleChanges} from "@angular/core";
import {Validators} from "@angular/forms";
import {Contact} from "../../company/company.model";
import {FormComponent} from "../form.component";
import {emailAddressValidator} from "@myshared/emailValidator";

type Form = {
  first_name: string;
  last_name: string;
  email?: string;
  invite?: boolean;
}

@Component({
    selector: 'app-contact-form',
    templateUrl: './contact-form.component.html',
    styleUrls: [],
    standalone: false
})
export class ContactFormComponent extends FormComponent<Contact> {
  @Input() showInvite: boolean = false;
  @Input() showMail: boolean = false;
  @Input() contact?: Contact;

  @Input() submitButtonLabel = 'app_update';

  formMapper(form: Form): Contact {
    const contact = new Contact();
    contact.id = this.contact?.id ?? '';
    contact.first_name = form.first_name;
    contact.last_name = form.last_name;
    contact.email = form?.email ?? '';
    contact.invite_user = form?.invite ?? false;
    return contact;
  }

  protected createForm() {
    this.form = this.fb.group({
      first_name: [this.contact?.first_name ?? "", Validators.required],
      last_name: [this.contact?.last_name ?? "", Validators.required],
      email: this.showMail ? ([this.contact?.email ?? "", [Validators.required, emailAddressValidator]]) : undefined,
      invite: this.showInvite ? [this.contact?.mypascom_account ?? false] : undefined,
    });
  }
}
